import { MUTED, INCIDENT_ACCENT, WARN_ORANGE } from '../colorTokens';

export const ALL_ALERT_STATES = ['Active', 'Paused'];

// Mutually-exclusive partition of every monitor by whether it has notify targets and/or a
// runbook link -- together these 4 always add up to the alert state's Total.
export const DOC_CATEGORIES = ['Notify and Runbook', 'Notify only', 'Runbook only', 'No Notify or Runbook'];

export const STATUS_COLORS = {
  Alert: INCIDENT_ACCENT,
  Warn: WARN_ORANGE,
  'No Data': MUTED,
  OK: '#2e7d32',
  Skipped: MUTED,
  Ignored: MUTED,
  Unknown: MUTED
};

// Active = green, Paused = red -- so monitors that are muted stand out from ones that are
// actively alerting/healthy in the monitors table.
export const ALERT_STATE_STYLES = {
  Active: { color: '#1b5e20', bg: '#e6f4ea' },
  Paused: { color: INCIDENT_ACCENT, bg: '#fdecea' }
};

// Applied to an inner wrapper div, not the <td> itself -- truncates content to at most
// 2 lines (with an ellipsis) instead of growing the row.
export const CLAMP_INNER_SX = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  overflowWrap: 'anywhere'
};
